import { withPropsOnChange } from 'recompose';
import uuid from 'uuid';
// TODO #001 Remove by updating RTE  @sinslav
export default withPropsOnChange(
  [
    'defaultFontSize',
    'defaultFont',
    'defaultFontColor',
    'defaultBold',
    'defaultItalic',
    'defaultUnderline',
  ],
  () => ({
    renderKey: uuid(), // need new key each time StaticText gets new style to re-rend er it with new defaultValues @sinslav
  }),
);
